import { useEffect, useRef } from 'react';
import { mountDashboard } from '../engine/dashboard/mount.ts';

// Thin React wrapper: routing/lifecycle only. All dashboard behavior (list,
// search, sort, create/rename/delete/import) lives in engine/dashboard,
// ported verbatim from legacy/dashboard.html so behavior stays identical.
export default function DashboardPage() {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = rootRef.current;
    if (!el) return;
    const unmount = mountDashboard(el);
    return unmount;
  }, []);

  return <div className="dashboard-root" ref={rootRef} />;
}
